import React, { useEffect } from 'react'
import Layout from '../component/Layout/Layout'

export default function OfflineAppointment() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);
  return (
    <Layout title="Online Appointment : Chaashni By MK" description="Chaashni Couture By : Description" >

    <div className='online-appointment-banner'><span>Online Appointment</span>{/* <img src='/images/online-Appointment.jpg' alt='online-Appointment' /> */}</div>
    <div className="site-content-wrap static-page calendly-page">
    <div className="container">     
      <div className="row">
        <div className="col-md-12">          
          <div className="content-box">                    
            <div className="calendly-inline-widget" data-url="https://calendly.com/hemant-at-techvoi/30min" style={{ minWidth: "320px", height: "700px" }} />
          </div>
        </div>
      </div>
    </div>
  </div>
  </Layout>
  )
}
